<div class="row-data" *ngIf="tables">
  <div class="col before">
    <ng-container *ngTemplateOutlet="positionTable; context: {legs: tables.before, title: 'Before'}"></ng-container>
  </div>
  <div class="col transaction">
    <table>
      <tr class="group-name"><td [attr.colspan]="(isAsset ? 3 : 5) + (acquiring ? 2 : 0)">Transaction</td></tr>
      <tr class="headers">
        <td>Action</td><td *ngIf="isAsset">Ticker</td><td>Qty</td>
        <ng-container *ngIf="!isAsset"><td>Type</td><td>Expiration</td><td>Strike</td></ng-container>
        <ng-container *ngIf="acquiring"><td>Fill Px</td><td>Market</td></ng-container>
      </tr>
      <tr *ngFor="let leg of tables.transaction; let index = index; trackBy: this.trackTransaction">
        <td [class.buy]="leg.qty > 0" [class.sell]="leg.qty < 0" [title]="leg.action || ''">{{ leg.qty > 0 ? 'Buy' : 'Sell' }}</td>
        <td *ngIf="isAsset">{{ tickerText(leg.ticker) }}</td><td>{{ leg.qty }}</td>
        <ng-container *ngIf="!isAsset">
          <td>{{ leg.kind === 0 ? tickerText(leg.ticker) : leg.type }}</td>
          <td>{{ leg.kind === 0 ? '' : (leg.expiration | etsFriendlyDatePipe:'full':leg.cursorDay) }}</td>
          <td>{{ leg.strike }}</td>
        </ng-container>
        <ng-container *ngIf="acquiring">
          <td class="fill-cell"><dx-number-box [min]="0" format="$#,##0.00" valueChangeEvent="input"
            [inputAttr]="centerText" [disabled]="busy" [value]="leg.fillPx"
            (valueChange)="fillChanged.emit({index: index, value: $event})"></dx-number-box></td>
          <td class="mkt-cell" [title]="leg.kind === 1 ? 'Option MID — market guidance only' : 'Last price — market guidance only'">{{ marketText(leg) }}</td>
        </ng-container>
      </tr>
    </table>
  </div>
  <div class="col after">
    <ng-container *ngTemplateOutlet="positionTable; context: {legs: tables.after, title: 'After'}"></ng-container>
  </div>
</div>

<ng-template #positionTable let-legs="legs" let-title="title">
  <table>
    <tr class="group-name"><td [attr.colspan]="isAsset ? 3 : 5">{{ title }}</td></tr>
    <tr class="headers">
      <td *ngIf="isAsset">Ticker</td><td>Qty</td><td>Side</td>
      <ng-container *ngIf="!isAsset"><td>Type</td><td>Expiration</td><td>Strike</td></ng-container>
    </tr>
    <tr *ngFor="let leg of legs">
      <td *ngIf="isAsset">{{ leg.qty === 0 ? '' : tickerText(leg.ticker) }}</td><td>{{ magnitude(leg.qty) }}</td>
      <td [class.buy]="leg.qty > 0" [class.sell]="leg.qty < 0">{{ side(leg.qty) }}</td>
      <ng-container *ngIf="!isAsset">
        <td>{{ leg.qty === 0 ? '' : (leg.kind === 0 ? tickerText(leg.ticker) : leg.type) }}</td>
        <td>{{ leg.qty === 0 || leg.kind === 0 ? '' : (leg.expiration | etsFriendlyDatePipe:'full':leg.cursorDay) }}</td>
        <td>{{ leg.qty === 0 ? '' : leg.strike }}</td>
      </ng-container>
    </tr>
  </table>
</ng-template>
